module.exports = __webpack_public_path__ + "img/line3.4c006b86.png";